import React from 'react';

/** RCT-04 (Phase 8): red "Recert overdue" badge on patient lists. */
const RecertOverdueBadge: React.FC<{ overdue?: boolean | null; className?: string }> = ({ overdue, className = '' }) => {
  if (!overdue) return null;
  return (
    <span
      data-testid="recert-overdue-badge"
      className={`inline-flex items-center rounded-full border border-red-300 bg-red-100 px-2 py-0.5 text-[11px] font-semibold text-red-800 ${className}`}
    >
      Recert overdue
    </span>
  );
};

export default RecertOverdueBadge;
